import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { LoadingButton } from "@mui/lab";
import popupMessage from "../../../services/popupMessage";
import imageUpload from "../../../services/upload";
import * as React from "react";
import {
  Card,
  CardContent,
  CardActions,
  Box,
  Breadcrumbs,
  FormControl,
  TextField,
  FormHelperText,
  Button,
  Typography,
  CardMedia,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IMAGE_PATH, instanceToken } from "../../../utils/constant";
const imgFileTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"];

export default function UpdatePopupMessage({ homeAlert }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({ title: "", image_url: "" });
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageFileUrl, setImageFileUrl] = useState("");
  const changeTitle = (e) => {
    setValues((prev) => ({
      ...prev,
      title: e.target.value.trim(),
    }));
  };

  async function getImageUrl(imgData) {
    const response = await imageUpload.getImageUrl(
      instanceToken.token,
      imgData
    );
    const result = response.data;
    const path = IMAGE_PATH + result?.imageName;
    console.log(result);
    setImageFileUrl(result?.imageUploadUrl);
    setValues({
      ...values,
      image_url: `https://axra.sgp1.digitaloceanspaces.com/CBLifeInsuranceLive/${result?.imageName}`,
    });
  }
  //for image url upload

  const changeFile = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const img = e.target.files[0];
      if (!imgFileTypes.includes(img.type)) {
        setErrors({
          ...errors,
          image_url: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
        });
        return;
      }
      if (img.size > 204800) {
        setErrors({
          ...errors,
          image_url: "Image file size must be smaller than 200KB.",
        });
        return;
      }
      setImageFile(img);
      setImagePreview(URL.createObjectURL(img));
      getImageUrl(img);
    }
  };
  const formData = new FormData();
  const handleCreate = async (e) => {
    e.preventDefault();

    formData.append("title", values.title);
    formData.append("image_url", values.image_url);
    try {
      setLoading(true);

      console.log("values is ", values);
      if (imageFile) {
        await imageUpload.uploadImage(imageFileUrl, imageFile);
      }

      const response = await popupMessage.update(
        instanceToken.token,
        id,
        formData
      );
      console.log("response is =========>", response);
      navigate("/popup-messages");

      homeAlert("Popup have been created.", false);
      setLoading(false);
    } catch (error) {
      console.log(error);
      homeAlert("File Upload Failed!", true);
    } finally {
      setLoading(false);
      setErrors({});
    }
  };

  React.useEffect(() => {
    async function fetchData() {
      try {
        const response = await popupMessage.findOne(instanceToken.token, id);
        setMessage(response?.data || {});
        setValues({
          title: response?.data?.title || "",
          image_url: response?.data?.image_url || "",
        });
      } catch (error) {
        console.error("Error fetching popup message:", error);
      }
    }
    fetchData();
  }, [id]);

  return (
    <>
      <div role="presentation" style={{ marginBlockEnd: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/popup-messages">Popup Message</Link>
          <span>Create Popup Message</span>
        </Breadcrumbs>
      </div>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Card sx={{ minWidth: "80vw" }}>
          <CardContent sx={{ display: "flex", pb: 0, flexDirection: "column" }}>
            <Box
              sx={{
                maxWidth: "40vw",
                display: "grid",
                justifyContent: "center",
                // bgcolor: "red",
                ml: 31,
                borderRadius: 2,
                boxShadow: 2,
              }}
            >
              <CardMedia
                component="img"
                height="320"
                image={imagePreview ? imagePreview : values?.image_url}
                sx={{ my: 2 }}
              />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {/* image */}

              <FormControl sx={{ my: 2, maxWidth: 400 }}>
                <Typography
                  sx={{
                    mb: 1,
                    fontSize: "12px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  Rendered size must be 1920 * 1080 px and Aspect ratio must be
                  16:9
                </Typography>

                <Button
                  variant="contained"
                  component="label"
                  size="large"
                  sx={{ p: 2 }}
                >
                  <PhotoCamera />
                  <Typography sx={{ ml: 1 }}>Upload Image</Typography>
                  <input
                    hidden
                    onChange={changeFile}
                    accept="image/png, image/jpeg, image/jpg, image/gif, image/svg+xml"
                    type="file"
                  />
                </Button>
                <FormHelperText error>{errors["image_url"]}</FormHelperText>
              </FormControl>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              {/* title Eng */}
              <FormControl sx={{ my: 2, maxWidth: 800 }} variant="outlined">
                <TextField
                  id="title"
                  label="Title (optional)"
                  value={values?.title}
                  onChange={changeTitle}
                  error={errors["title"]}
                  helperText={errors["title"]}
                />
              </FormControl>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            ></Box>

            <Box
              sx={{
                flex: 2,
                display: "flex",
                flexDirection: "column",
                px: 3,
              }}
            ></Box>
          </CardContent>

          <CardActions sx={{ justifyContent: "end" }}>
            <LoadingButton
              variant="contained"
              loading={loading}
              onClick={handleCreate}
              sx={{ backgroundColor: "#4b26d1", alignSelf: "end" }}
            >
              Update
            </LoadingButton>
          </CardActions>
        </Card>
      </Box>
    </>
  );
}
